import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopNavBar } from './TopNavBar';
import { useTheme } from '../../context/ThemeContext';
import { motion } from 'framer-motion';

export const DashboardLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { isDark, colors } = useTheme();
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile/desktop
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div 
      className="min-h-screen transition-colors duration-300"
      style={{ backgroundColor: 'var(--bg-primary)' }}
    >
      {/* Background Effects - Different for light/dark mode */}
      <div className="fixed inset-0 pointer-events-none overflow-hidden">
        {isDark ? (
          <>
            {/* Dark mode: Subtle gradient orbs */}
            <div 
              className="absolute top-0 left-1/4 w-[500px] h-[500px] rounded-full blur-[150px] opacity-30"
              style={{ backgroundColor: 'var(--color-primary)' }}
            />
            <div 
              className="absolute bottom-0 right-1/4 w-[400px] h-[400px] rounded-full blur-[150px] opacity-20"
              style={{ backgroundColor: 'var(--color-secondary)' }}
            />
          </>
        ) : (
          <>
            {/* Light mode: Very subtle warm gradient */}
            <div 
              className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full blur-[200px] opacity-[0.03]"
              style={{ backgroundColor: '#E6006E' }}
            />
            <div 
              className="absolute bottom-0 left-0 w-[500px] h-[500px] rounded-full blur-[200px] opacity-[0.02]"
              style={{ backgroundColor: '#6B21A8' }}
            />
          </>
        )}
      </div>

      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      <motion.main
        initial={false}
        animate={{ marginLeft: isMobile ? 0 : (collapsed ? 80 : 256) }}
        transition={{ type: 'spring', damping: 25, stiffness: 200 }}
        className="min-h-screen relative z-10"
      >
        {/* Top Navigation Bar with Back Button & Theme Toggle */}
        <TopNavBar />
        
        <div className="p-4 lg:p-8">
          <Outlet />
        </div>
      </motion.main>
    </div>
  );
};
